import React, { useState, useEffect } from 'react';
import MarkdownComponent from 'containers/user/learn/components/markdown/markdown';

import Icons from 'assets/icons';

interface CalloutDef {
  type: string;
  icon: React.ReactNode;
  color: string;
  calloutNameColor: string;
}

const CALLOUTS: CalloutDef[] = [
  {
    type: 'tip',
    icon: <Icons.Active aria-label="tip-icon" />,
    color: 'bg-success-100',
    calloutNameColor: 'text-success-800',
  },
  {
    type: 'note',
    icon: <Icons.Info aria-label="note-icon" />,
    color: 'bg-amber-100',
    calloutNameColor: 'text-amber-950',
  },
  {
    type: 'warning',
    icon: <Icons.Warning aria-label="warning-icon" />,
    color: 'bg-warning-100',
    calloutNameColor: 'text-critical-950',
  },
];

interface CalloutProps {
  variant?: string;
  text?: string;
}

const Callout = ({
  variant = 'tip',
  text = 'Some text',
}: CalloutProps): React.JSX.Element => {
  const [callout, setCallout] = useState<Omit<CalloutDef, 'type'> | undefined>({
    icon: <Icons.Active aria-label="tip-icon" />,
    color: 'bg-success-100',
    calloutNameColor: 'text-success-800',
  });

  useEffect(() => {
    setCallout(CALLOUTS.find((el) => el.type === variant));
  }, []);

  return (
    <div
      className={`flex flex-col ${callout?.color} rounded-md p-6 mobile:mb-6 xs:mb-8 w-full`}
    >
      <div className={`flex items-center pb-1 ${callout?.calloutNameColor}`}>
        {callout?.icon}
        <div className="pl-2 font-semibold capitalize-first">{variant}</div>
      </div>
      <MarkdownComponent text={text} />
    </div>
  );
};

export default Callout;
